import { writable } from "svelte/store";
const initialValue = {
    snippet: null,
};
const store = () => {
    const { subscribe, update } = writable(initialValue);
    function setSnippet(snippet) {
        update(() => ({ snippet: snippet }));
    }
    return {
        subscribe,
        setSnippet,
    };
};
export const snippetSidePanelStore = store();
